// extracted by mini-css-extract-plugin
export default {"message-box":"message_message-box__ohiR3","success":"message_success__bsUKI","error":"message_error__fVcAH","warning":"message_warning__JvmWs"};